import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/affiliate-program',
        name: 'Affiliate program',
        meta: {
            layout: 'main',
            requiresAuth: true
        },
        component: () => import('../views/AffiliateCharts/AffiliateProgram.vue'),
    },
    {
        path: '/affiliate',
        name: 'Affiliate',
        meta: {
            layout: 'main',
            requiresAuth: true
        },
        component: () => import('../views/AffiliateProgram/Affiliate.vue'),
    },
    {
        path: '/test',
        name: 'uitoolkit',
        meta: {
            layout: 'main',
            requiresAuth: true
        },
        component: () => import('../views/VerificationNewMail/VerificationNewMail.vue'),
    },
    {
        path: '/admin',
        name: 'administration-items',
        meta: {
            layout: 'main',
            requireAdminRoot: true,
            requiresAuth: true,
        },
        component: () => import('../views/admin/Administration/Administration.vue')
    },
    {
        path: '/admin/blog',
        name: 'administration-blog',
        meta: {
            layout: 'main',
            requireAdminRoot: true,
            requiresAuth: true,
        },
        component: () => import('../views/admin/Blog/Blog.vue')
    },
    {
        path: '/admin/blog/new',
        name: 'administration-blog-create',
        meta: {
            layout: 'main',
            requireAdminRoot: true,
            requiresAuth: true,
        },
        component: () => import('../views/admin/BlogCreate/BlogCreate.vue')
    },
    {
        path: '/admin/blog/:id',
        name: 'administration-blog-update',
        meta: {
            layout: 'main',
            requireAdminRoot: true,
            requiresAuth: true,
        },
        component: () => import('../views/admin/BlogUpdate/BlogUpdate.vue')
    },
    {
        path: '/',
        name: 'Home',
        meta: {
            layout: 'empty'
        },
        component: () => import(/* Home */'../views/Home/Home.vue')
    },
    {
        path: '/home',
        name: 'New home',
        meta: {
            layout: 'empty'
        },
        component: () => import('../views/NewHome/Home.vue')
    },
    {
        path: '/blog',
        name: 'Blog',
        meta: {
            layout: 'empty'
        },
        component: () => import('../views/PublicBlog/PublicBlog.vue')
    },
    {
        path: '/blog/:name',
        name: 'Blog Note',
        meta: {
            layout: 'empty'
        },
        component: () => import('../views/PublicBlogItem/PublicBlogItem.vue')
    },
    {
        path: '/terms-of-service',
        name: 'Terms of service',
        meta: {
            layout: 'main'
        },
        component: () => import('../views/TermsOfService/TermsOfService.vue'),
    },
    {
        path: '/privacy-policy',
        name: 'Privacy Policy',
        meta: {
            layout: 'main'
        },
        component: () => import('../views/PrivacyPolicy/PrivacyPolicy.vue'),
    },
    {
        path: '/project/:project',
        name: 'Project',
        meta: {
            layout: 'empty'
        },
        component: () => import('../views/Project/Project.vue'),
    },
    {
        path: '/instruction',
        name: 'Instruction',
        meta: {
            layout: 'main',
        },
        component: () => import('../views/Instruction/Instruction.vue')
    },
    {
        path: '/my-gates',
        name: 'Shared',
        meta: {
            layout: 'main',
            requiresAuth: true,
            requiresActivate: true
        },
        component: () => import('../views/Shared/Shared.vue'),
        props: true
    },
    {
        path: '/my-gates/:id/analytics',
        name: 'Analytics Page',
        meta: {
            layout: 'main',
            requiresAuth: true,
            requiresActivate: true
        },
        component: () => import('../views/StatisticsPage/StatisticsPage.vue'),
        props: true
    },
    {
        path: '/my-gates/:id/settings',
        name: 'Settings Page',
        meta: {
            layout: 'main',
            requiresAuth: true,
            requiresActivate: true
        },
        component: () => import('../views/UpdateSettings/UpdateSettings.vue'),
        props: true
    },
    {
        path: '/secure',
        name: 'Secure',
        meta: {
            layout: 'main',
            forUnauthorized: true,
        },
        component: () => import('../views/RequirementRegister/RequirementRegister.vue'),
        props: true
    },
    {
        path: '/login',
        name: 'Login',
        meta: {
            layout: 'main',
            forUnauthorized: true,
        },
        component: () => import('../views/Login/Login.vue'),
        props: true
    },
    {
        path: '/registration',
        name: 'Registration',
        meta: {
            layout: 'main',
            forUnauthorized: true,
        },
        component: () => import('../views/Registration/Registration.vue'),
        props: true
    },
    {
        path: '/please-activate',
        name: 'Please activate',
        meta: {
            layout: 'main',
            requiresAuth: true,
        },
        component: () => import('../views/PleaseActivate/PleaseActivate.vue'),

    },
    {
        path: '/new-gate',
        name: 'SharedSettings',
        meta: {
            layout: 'main',
            requiresAuth: true,
            requiresActivate: true
        },
        component: () => import('../views/CreateUpdateGate/CreateUpdateGate'),
    },
    {
        path: '/support',
        name: 'Support',
        meta: {
            layout: 'main',
            requiresAuth: false
        },
        component: () => import('../views/Support/Support.vue')
    },
    {
        path: '/support/ticket/:id',
        name: 'Support ticket',
        meta: {
            layout: 'main',
            requiresAuth: false
        },
        component: () => import('../views/SupportDialog/SupportDialog.vue')
    },
    {
        path: '/profile-settings',
        name: 'Profile Settings',
        meta: {
            layout: 'main',
            requiresAuth: true,
            requiresActivate: true
        },
        component: () => import('../views/Account/Account.vue'),
    },
    // {
    //     path: '/profile-settings/change-password',
    //     name: 'ChangePassword',
    //     meta: {
    //         layout: 'main',
    //         requiresAuth: true
    //     },
    //     component: () => import('../views/ChangePassword/ChangePassword.vue'),
    // },
    {
        path: '/profile-settings/change-password',
        name: 'ChangePassword',
        meta: {
            layout: 'main',
            requiresAuth: true
        },
        component: () => import('../views/ChangePassword/ChangePassword.vue')
    },
    {
        path: '/profile-settings/reset-password/:token',
        name: 'Reset password',
        meta: {
            layout: 'main',
        },
        component: () => import('../views/ResetPassword/ResetPassword.vue'),
    },
    {
        path: '/profile-settings/activate/:token',
        name: 'Verification email',
        meta: {
            layout: 'main',
        },
        component: () => import('../views/Activate/Activate.vue'),
    },
    {
        path: '/profile-settings/change-email/:token',
        name: 'Verification new email',
        meta: {
            layout: 'main',
        },
        component: () => import('../views/VerificationNewMail/VerificationNewMail.vue'),
    },
    {
        path: '/prove/:token',
        name: 'Client email confirm',
        meta: {
            layout: 'main',
        },
        component: () => import('../views/ClientEmailConfirm/ClientEmailConfirm.vue'),
    },
    {
        path: '/profile-settings/confirm/:token',
        name: 'Activate email',
        meta: {
            layout: 'main',
        },
        component: () => import('../views/ConfirmEmail/ConfirmEmail.vue'),
    },
    {
        path: '/reset',
        name: 'Reset',
        meta: {
            layout: 'main',
        },
        component: () => import('../views/Reset/Reset.vue'),
    },
    {
        path: '/statistics',
        name: 'statistics',
        meta: {
            layout: 'main',
            requiresAuth: true
        },
        component: () => () => import('../views/StatisticsPage/StatisticsPage.vue'),
    },
    {
        path: '/pricing',
        name: 'Pricing',
        meta: {
            layout: 'main'
        },
        component: () => import('../views/Pricing/Pricing.vue')
    },
    {
        path: '/pricing/:plan_name',
        alias: '/pricing/:plan_id',
        name: 'PricingDetails',
        meta: {
            layout: 'main'
        },
        component: () => import('../views/PricingDetails/PricingDetails.vue'),
        props: true
    },
    {
        path: '/pricing/pay/success',
        name: 'success_pay',
        meta: {
            layout: 'main'
        },
        component: () => import('../views/SuccessPay/SuccessPay.vue'),
    },
    {
        path: '/pricing/pay/error',
        name: 'pricing_error',
        meta: {
            layout: 'main'
        },
        component: () => import('../views/ErrorPay/ErrorPay.vue'),
    },
    {
        path: "/not-found",
        name: 'Not Found',
        meta: {
            layout: 'empty'
        },
        component: () => import('../views/PageNotFound/PageNotFound.vue')
    },
    {
        path: '/:name',
        name: 'Personal project',
        meta: {
            layout: 'empty'
        },
        component: () => import('../views/Project/Project.vue'),
    },
    {
        path: '/:tag_1/:tag_2',
        name: 'Personal project tags',
        meta: {
            layout: 'empty'
        },
        component: () => import('../views/Project/Project.vue'),
    },
    // {
    //     path: '/v2/:name',
    //     name: 'Personal project',
    //     meta: {
    //         layout: 'empty'
    //     },
    //     component: () => import('../views/Project_v2/Project_v2.vue'),
    // },
    {
        path: "*",
        name: '404',
        meta: {
            layout: 'empty'
        },
        component: () => import('../views/PageNotFound/PageNotFound.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})
router.beforeEach((to, from, next) => {
    if (store.getters.isLoggedIn) {
        store.dispatch('check_new_messages').then(() => {});
        // store.dispatch('getDetails').then(() => {})
        store.dispatch('details').then(() => {})
    }
    store.dispatch('changeRouterTo', to);
    store.dispatch('changeRouterFrom', from);

    let scrollAnimateParams = {top: 0, behavior: 'smooth'};

    if (to.matched.some(record => record.meta.forUnauthorized) && store.getters.isLoggedIn) {
        next('/my-gates');
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn || store.getters.isActive) {
            if (to.matched.some(record => record.meta.requiresActivate)) {
                if (store.getters.isActive) {
                    next()
                    window.scrollTo(scrollAnimateParams)
                } else {
                    next('/please-activate')
                }
            } else if (to.matched.some(record => record.meta.requireAdminRoot)) {
                store.dispatch('getDetails').then(() => {
                    if (store.getters.isAdmin) {
                        next()
                    } else {
                        next('/not-found')
                    }
                })
            } else {
                next()
                window.scrollTo(scrollAnimateParams)
            }
        } else {
            next('/secure')
        }
    } else {
        next()
        window.scrollTo(scrollAnimateParams)
    }

})


export default router
